import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import styles from './NftNavBar.module.css';

type Props = {
    align?: 'center' | 'left';
    fullWidth?: boolean;
    overflowContainer?: boolean;
    children: ReactNode;
};

export const NftNavBar: FC<Props> = ({
    children,
    align = 'left',
    fullWidth,
    overflowContainer,
}) => {
    return (
        <nav>
            <div
                className={classnames(styles.container, styles[align], {
                    [styles.fullWidth]: fullWidth,
                    [styles.overflowContainer]: overflowContainer,
                })}
            >
                <ul
                    className={classnames(styles.tabList, styles[align], {
                        [styles.fullWidth]: fullWidth,
                    })}
                >
                    {children}
                </ul>
            </div>
        </nav>
    );
};
